/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { StopOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Input, Col, Modal, Typography, Row, message } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { Button } from 'shared/components';
import { PaymentOrderContext } from 'views/AccountPayment/common/context/PaymentOrderContext';
import { FormValues } from 'views/AccountPayment/Routes/PaymentOrder/ModalDetailPaymentOrder/model/formValues.model';
import UPDATE_PAYMENT_MUTATION, {
  UpdatePaymentData,
  UpdatePaymentVars,
} from 'shared/graphql/mutation/updatePayment';
import { useFormContext, Controller } from 'react-hook-form';
import formatCurrency from 'shared/utils/formatCurrency';

const { Text } = Typography;

type ModalConfirmCancelProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmCancel: React.FC<ModalConfirmCancelProps> = (props) => {
  const { onCancel, visible } = props;
  const { selectedPaymentDetail: selectedPaymentDetailContext } = useContext(PaymentOrderContext);
  const [selectedPaymentDetail, setSelectedPaymentDetail] = selectedPaymentDetailContext;
  const { watch, reset, control } = useFormContext<FormValues>();

  const watchEmployeeFullName = watch('employeeFullName');
  const watchPayeeName = watch('payeeName');
  const watchGrandTotalPrice = watch('grandTotalPrice');
  const watchCancelRemark = watch('cancelRemark');

  const closeModalHandler = () => {
    setSelectedPaymentDetail((prevState) => ({
      ...prevState,
      isOpenModal: false,
    }));
  };

  const [updatePayment, { loading }] = useMutation<UpdatePaymentData, UpdatePaymentVars>(
    UPDATE_PAYMENT_MUTATION,
    {
      update: (_cache, { data }) => {
        if (data?.updatePayment._id) {
          message.success('เปลี่ยนสถานะใบสั่งจ่ายแล้ว');
          onCancel();
          reset();
          closeModalHandler();
        }
      },
      onError: (err) => {
        message.error(err.message);
      },
      refetchQueries: () => ['Payment', 'PaymentStatus', 'Payments'],
    },
  );

  const confirmCancel = () => {
    updatePayment({
      variables: {
        _id: selectedPaymentDetail.paymentId,
        payment_status: 5,
        cancel_remark: watchCancelRemark,
      },
    });
  };

  return (
    <Modal
      title="ยกเลิกการใช้ใบสั่งจ่ายนี้หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<StopOutlined />}
          color="red"
          onClick={() => confirmCancel()}
          loading={loading}
          disabled={!watchCancelRemark}
        >
          ยกเลิกการใช้
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>ผู้ตั้งเบิก:</Col>
        <Col span={18}>
          <Text strong>{watchEmployeeFullName}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>ผู้รับเงิน:</Col>
        <Col span={18}>
          <Text strong>{watchPayeeName}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>มูลค่าใบสั่งจ่าย:</Col>
        <Col span={18}>
          <Text strong>{formatCurrency(watchGrandTotalPrice, '0')}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          เหตุผล:<Text type="danger">*</Text>
        </Col>
        <Col span={18}>
          <Controller as={Input} name="cancelRemark" control={control} placeholder="ระบุเหตุผล" />
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalConfirmCancel;
